<button 
  [ngClass]="[getClassName(), 'btn']"
  (click)="execute()"
  [disabled]="isCompleted() && !isAction()">
  <i class="fa" *ngIf="getIconClassName()" [ngClass]="getIconClassName()"></i>
  {{ getTaskName() }}
</button>